import React from 'react';

import colors from '@atom/styles/colors';
import fonts from '@atom/styles/fonts';

const styles = {
  tooltip: {
    padding: '0.75rem 1rem',
    border: `1px solid ${colors.neutral.ash}`,
    borderRadius: '0.5rem',
    backgroundColor: colors.neutral.white,
    fontSize: fonts.md,
    color: colors.neutral.dark,
  },
};

type ConversationalAnalyticsChartTooltipProps = {
  active?: boolean;
  payload?: readonly any[];
  xDisplayField: string;
};

const ConversationalAnalyticsChartTooltip: React.FC<
  ConversationalAnalyticsChartTooltipProps
> = ({ active, payload, xDisplayField }) => {
  if (!active || !payload || payload.length === 0) {
    return null;
  }

  return (
    <div style={styles.tooltip}>
      {payload.map((entry, index) => {
        const formattedValue =
          typeof entry.value === 'number'
            ? entry.value.toLocaleString()
            : entry.value;

        return (
          <div key={index}>
            {entry.payload[xDisplayField]}: {formattedValue}
          </div>
        );
      })}
    </div>
  );
};

export default ConversationalAnalyticsChartTooltip;
